/* MD Opiniones: flechas del slider de opiniones (el scroll y el snap son nativos) */
(function () {
  'use strict';

  /* Limpieza por instancia (observer o listener de resize) para el evento unload del editor */
  var cleanups = new WeakMap();

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    var list = container.querySelector('.md-opiniones__list');
    var prev = container.querySelector('.md-opiniones__arrow--prev');
    var next = container.querySelector('.md-opiniones__arrow--next');
    if (!list || !prev || !next) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function slideWidth() {
      var item = list.querySelector('.md-opiniones__item');
      return item ? item.getBoundingClientRect().width : list.clientWidth;
    }

    /* aria-disabled en vez de disabled: la flecha no pierde el foco de teclado al llegar al extremo */
    function setDisabled(button, disabled) {
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function update() {
      var maxScroll = list.scrollWidth - list.clientWidth;
      var scrollable = maxScroll > 1;
      container.classList.toggle('md-opiniones--scrollable', scrollable);
      setDisabled(prev, list.scrollLeft <= 1);
      setDisabled(next, list.scrollLeft >= maxScroll - 1);
    }

    /* Una sola lectura de layout por frame durante el scroll o el resize */
    var pending = false;
    function scheduleUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        update();
      });
    }

    function move(direction) {
      return function () {
        if (this.getAttribute('aria-disabled') === 'true') return;
        list.scrollBy({
          left: direction * slideWidth(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      };
    }

    prev.addEventListener('click', move(-1));
    next.addEventListener('click', move(1));
    list.addEventListener('scroll', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(scheduleUpdate);
      observer.observe(list);
      cleanups.set(container, function () { observer.disconnect(); });
    } else {
      window.addEventListener('resize', scheduleUpdate);
      cleanups.set(container, function () { window.removeEventListener('resize', scheduleUpdate); });
    }

    update();
  }

  function destroySection(container) {
    var cleanup = cleanups.get(container);
    if (!cleanup) return;
    cleanup();
    cleanups.delete(container);
    delete container.dataset.mdInit;
  }

  var sections = document.querySelectorAll('.md-opiniones');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.md-opiniones');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.md-opiniones');
    if (section) destroySection(section);
  });
})();
